import React from 'react';
import styled from 'styled-components';
import { vars } from '../../theme';
import colors from '../../styles/colors';

interface Props {
    count: number;
    activeIndex: number;
}

const PaginationDots = ({ count, activeIndex }: Props) => (
    <Container>
        {Array.from({ length: count }).map((_, index) => (
            <Dot key={index} $isActive={index === activeIndex} />
        ))}
    </Container>
);

export default PaginationDots;

// -------------------------- Styles -------------------------- //

const Container = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

const Dot = styled.div<{ $isActive: boolean }>`
    width: 8px;
    height: 8px;
    border-radius: ${vars.radius.full};
    transition: background-color 200ms;
    background-color: ${({ $isActive }) =>
        $isActive ? colors.neutral900 : colors.neutral500};
`;
